import {
  FETCH_PRACTICE_TYPES,
  FETCH_PRACTICE_TYPES_SUCCESS,
  FETCH_PRACTICE_TYPES_FAILED,
  EDIT_PRACTICE_TYPE
} from "../store/types";

const INITIAL_STATE = {
  practices: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const practicetypesreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PRACTICE_TYPES:
      return {
        ...state,
        loading: true
      };
    case FETCH_PRACTICE_TYPES_SUCCESS:
      return {
        ...state,
        practices: action.payload,
        loading: false
      };
    case FETCH_PRACTICE_TYPES_FAILED:
      return {
        ...state,
        practices: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_PRACTICE_TYPE:
      return state;
    default:
      return state;
  }
};
